import clsx from 'clsx'
import type { ReactNode } from 'react'
import { Platform } from 'react-native'

import { ImageCard, type TImageCard } from '@/src/elements/card/image'

type TCategoryCardProps = TImageCard & {
  resetSizes?: boolean
}

export const CategoryCard = ({ className, resetSizes, ...props }: TCategoryCardProps): ReactNode => (
  <ImageCard
    className={clsx(
      !resetSizes &&
        'l:w-[26%] h-[120px] min-h-[120px] min-w-[46%] sm:min-w-[46%]  xm:min-w-[21%]  md:min-w-[21%] last:md:max-w-[50%]  lg:h-[340px] lg:min-w-[21%]',
      className,
    )}
    shadowInner={Platform.OS === 'ios' ? undefined : true}
    typographyClassName="text-md xl:text-2xl lg:text-xl"
    textContainerClassName="py-2 px-4 lg:py-4 lg:px-6"
    contentFit="cover"
    contentPosition="center"
    {...props}
  />
)
